<template>
    <kt-panel>
        <kt-panel-body>
            <div class="d-flex align-items-center px-3">
                <div>
                    <svg fill="#00bea5" height="24px" viewBox="0 -960 960 960" width="24px" xmlns="http://www.w3.org/2000/svg">
                        <path d="M280-400q-33 0-56.5-23.5T200-480q0-33 23.5-56.5T280-560q33 0 56.5 23.5T360-480q0 33-23.5 56.5T280-400Zm0 160q-100 0-170-70T40-480q0-100 70-170t170-70q67 0 121.5 33t86.5 87h352l120 120-180 180-80-60-80 60-85-60h-47q-32 54-86.5 87T280-240Zm0-80q56 0 98.5-34t56.5-86h125l58 41 82-61 71 55 75-75-40-40H435q-14-52-56.5-86T280-640q-66 0-113 47t-47 113q0 66 47 113t113 47Z"/>
                    </svg>
                    <span class="px-2">افزودن توکن سرویس خارجی</span>
                </div>
            </div>
            <hr/>

            <div class="p-3">
                <!-- Existing tokens -->
                <div class="mb-4">
                    <label class="d-block mb-2">توکن‌های فعال</label>
                    <div v-if="tokens_loading" class="p-2">
                        <div class="spinner-border spinner-border-sm text-success" role="status"></div>
                        <span class="p-2">لطفا صبر کنید</span>
                    </div>
                    <div v-else-if="tokens.length === 0" class="text-muted text-white-in-dark-mode p-2">
                        هنوز توکنی ایجاد نشده است.
                    </div>
                    <div v-else class="table-responsive application-tokens-table-wrapper">
                        <table class="table table-sm mb-0 text-center text-nowrap application-tokens-table">
                            <thead>
                            <tr>
                                <th class="text-center text-white-in-dark-mode">نوع</th>
                                <th class="text-center text-white-in-dark-mode">آی‌پی / مرورگر</th>
                                <th class="text-center text-white-in-dark-mode">تاریخ ایجاد</th>
                                <th class="text-center text-white-in-dark-mode">تاریخ انقضا</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="token in tokens" :key="token.id">
                                <td>
                                    <span class="badge badge-pill text-white application-token-type" :style="{ backgroundColor: typeColor(token.type) }">
                                        {{ typeLabel(token.type) }}
                                    </span>
                                </td>
                                <td class="en_num small application-token-device" dir="ltr">{{ [token.ip, token.browser].filter(Boolean).join(' · ') }}</td>
                                <td>{{ token.created_at }}</td>
                                <td>
                                    <span v-if="token.expires_at">{{ token.expires_at }}</span>
                                    <span v-else class="badge badge-pill application-token-no-expiry">بدون انقضا</span>
                                </td>
                                <td class="text-right text-nowrap">
                                    <template v-if="revoke_confirm_id === token.id">
                                        <span class="small mr-2">آیا مطمئن هستید؟</span>
                                        <button type="button" class="btn btn-sm btn-danger application-token-action"
                                                :disabled="revoking_id === token.id"
                                                @click="revokeToken(token)">
                                            بله
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light application-token-action"
                                                @click="revoke_confirm_id = null">
                                            خیر
                                        </button>
                                    </template>
                                    <button v-else type="button" class="btn btn-sm btn-outline-danger application-token-action"
                                            title="حذف توکن" @click="revoke_confirm_id = token.id">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Newly generated token -->
                <div v-if="generated_token" class="mb-4">
                    <label for="generated_application_token">توکن ایجاد شده</label>
                    <div class="input-group">
                        <input id="generated_application_token" type="text" readonly dir="ltr"
                               class="form-control text-left" :value="generated_token">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-success" title="کپی"
                                    @click="copyToken">
                                <i :class="copied ? 'fa fa-check' : 'fa fa-copy'"></i>
                            </button>
                        </div>
                    </div>
                    <small class="text-warning d-block mt-1">
                        این توکن فقط یک بار نمایش داده می‌شود؛ آن را در جای امنی ذخیره کنید.
                    </small>
                </div>

                <!-- Generate form -->
                <form @submit.prevent="generateToken">
                    <div class="alert alert-danger" v-if="error_message">{{ error_message }}</div>
                    <div class="d-flex align-items-end flex-wrap">
                        <div class="form-group w-50 pr-3">
                            <label for="application_token_type">نوع</label>
                            <select id="application_token_type" class="form-control" v-model="form_data.type" required>
                                <option :value="null" disabled>انتخاب کنید</option>
                                <option v-for="option in type_options" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group pr-3">
                            <label for="application_token_expires_at">تاریخ انقضا</label>
                            <date-picker
                                v-model="form_data.expires_at"
                                type="datetime"
                                name="expires_at"
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jYYYY/jMM/jDD HH:mm"
                                placeholder="انتخاب تاریخ و ساعت"
                                id="application_token_expires_at"
                                input-class="form-control"
                                :disabled="form_data.never_expires"
                                clearable
                            />
                        </div>
                        <div class="form-group pr-3">
                            <div class="custom-control custom-checkbox">
                                <input id="application_token_never_expires" type="checkbox" class="custom-control-input"
                                       v-model="form_data.never_expires" @change="form_data.expires_at = null">
                                <label class="custom-control-label" for="application_token_never_expires">بدون انقضا</label>
                            </div>
                        </div>
                        <div class="form-group ml-auto">
                            <button type="submit" id="generate_application_token_btn" class="btn btn-success px-4"
                                    style="border-radius: 10px" :disabled="!can_generate">
                                ایجاد توکن
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import $ from 'jquery';
import { userService } from '@/common/api.service';
import { KTApp } from '@/plugins/core/app';
import {
    applicationTokenTypeColor,
    applicationTokenTypeLabel,
    applicationTokenTypeOptions,
} from '@/constants/applicationTokenTypes';

export default {
    name: 'application-tokens',
    data() {
        return {
            type_options: applicationTokenTypeOptions(),
            tokens: [],
            tokens_loading: false,
            form_data: {
                type: null,
                expires_at: null,
                never_expires: false,
            },
            generated_token: null,
            copied: false,
            error_message: null,
            revoke_confirm_id: null,
            revoking_id: null,
        };
    },
    computed: {
        can_generate() {
            return !!this.form_data.type && (this.form_data.never_expires || !!this.form_data.expires_at);
        },
    },
    mounted() {
        this.fetchTokens();
    },
    methods: {
        typeLabel(type) {
            return applicationTokenTypeLabel(type);
        },
        typeColor(type) {
            return applicationTokenTypeColor(type);
        },
        fetchTokens() {
            this.tokens_loading = true;
            userService
                .fetchApplicationTokens({ perpage: 100 })
                .then(({ data }) => {
                    this.tokens = data.data.data;
                })
                .catch(({ response }) => {
                    this.error_message = response && response.data ? response.data.message : null;
                })
                .finally(() => {
                    this.tokens_loading = false;
                });
        },
        generateToken() {
            const btn = $('#generate_application_token_btn');
            this.error_message = null;
            this.generated_token = null;
            this.copied = false;

            KTApp.progress(btn);
            userService
                .generateApplicationToken(this.generatePayload())
                .then(({ data }) => {
                    this.generated_token = data.data.token;
                    this.toastr.success(data.message);
                    // A same-type token on this device is replaced server-side, so refresh the list.
                    this.fetchTokens();
                })
                .catch(({ response }) => {
                    this.error_message = response && response.data ? response.data.message : null;
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                });
        },
        generatePayload() {
            const { type, expires_at, never_expires } = this.form_data;

            return never_expires ? { type, auto_expiry: false } : { type, expires_at };
        },
        copyToken() {
            this.$copyText(this.generated_token).then(() => {
                this.copied = true;
                this.toastr.success('در حافظه کپی شد');
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            });
        },
        revokeToken(token) {
            this.revoking_id = token.id;
            userService
                .revokeApplicationToken(token.id)
                .then(({ data }) => {
                    this.toastr.success(data.message);
                    this.fetchTokens();
                })
                .catch(({ response }) => {
                    this.toastr.error(response && response.data && response.data.message
                        ? response.data.message
                        : 'حذف توکن با خطا مواجه شد');
                })
                .finally(() => {
                    this.revoking_id = null;
                    this.revoke_confirm_id = null;
                });
        },
    },
};
</script>

<style scoped>
.application-tokens-table-wrapper {
    border: 1px solid #ebedf2;
    border-radius: 10px;
}

.application-tokens-table th,
.application-tokens-table td {
    border: 0;
    padding: 12px 16px;
    vertical-align: middle;
}

.application-tokens-table thead th {
    background-color: #f7f8fa;
    color: #74788d;
    font-weight: 500;
}

.application-tokens-table tbody tr + tr td {
    border-top: 1px solid #f0f1f5;
}

.application-tokens-table tbody tr {
    transition: background-color 0.15s;
}

.application-tokens-table tbody tr:hover {
    background-color: #f9fafc;
}

.application-token-device {
    color: #595d6e;
}

.application-token-type {
    font-weight: 500;
    padding: 6px 12px;
}

.application-token-no-expiry {
    background-color: #e6f8f5;
    color: #00a58c;
    font-weight: 500;
    padding: 6px 12px;
}

.application-token-action {
    border-radius: 8px;
    padding: 2px 10px;
}
</style>
